<template>
	<page enable-flex>
		<view-list ref="view" work-type="7" :search="{scan: true}">
			<template #filter>
				<m-search>
					<m-search-item label="产品信息">
						<c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
					</m-search-item>
					<m-search-item label="创建时间">
						<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
					</m-search-item>
				</m-search>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #tag>
						<c-state dict="LEVEL_TYPE" :value="data.level_type" type="hollow"></c-state>
					</template>

					<template #name>
						{{[data.brand_name, data.model_name, data.memory_name, data.color_name].filter(item => item).join(' ') || '-'}}
					</template>

					<template #state>
						<c-state dict="qualityStateDic" :value="data.quality_state" type="state"></c-state>
					</template>

					<template #default>
						<!-- 在途天数是接驳派生指标，H5 卡片是写死模板、不吃视图列配置，门店版不渲染 -->
						<c-field v-if="hasHandover" label="在途天数">{{data.in_transit_days}}天</c-field>
						<c-field label="背贴码">{{data.produce_unique_code}}</c-field>
						<c-field label="IMEI">{{data.produce_imei}}</c-field>
						<c-field label="B端质检报告"><c-state dict="qualityReportStateDic" :value="data.b_report_state"></c-state></c-field>
						<c-field label="C端质检报告"><c-state dict="qualityReportStateDic" :value="data.c_report_state"></c-state></c-field>
					</template>

					<template #operate>
						<c-button v-if="data.buttons?.confirm_reject?.visible && auth('b_app_quality_confirm_reject')" color="main" hollow @click="confirmReject(data)">同意驳回</c-button>
						<c-button v-if="data.buttons.view_report?.visible && auth('b_app_quality_view_report')" hollow @click="mp.navigateWeb('/sales/product/report', {code: data.produce_unique_code})">质检报告</c-button>
						<c-button v-if="data.buttons.publish_b_report?.visible && auth('b_app_quality_publish_b')" hollow @click="publishReport(data, 1)">发布B端</c-button>
						<c-button v-if="data.buttons.publish_c_report?.visible && auth('b_app_quality_publish_c')" hollow @click="publishReport(data, 2)">发布C端</c-button>
						<c-button v-if="data.buttons.unpublish_b_report?.visible && auth('b_app_quality_unpublish_b')" hollow @click="unpublishReport(data, 1)">下架B端</c-button>
						<c-button v-if="data.buttons.unpublish_c_report?.visible && auth('b_app_quality_unpublish_c')" hollow @click="unpublishReport(data, 2)">下架C端</c-button>
						<c-button v-if="data.buttons.transfer?.visible && auth('b_app_quality_transfer')" @click="mp.navigateWeb('/stock/allot', {code: data.produce_unique_code, from: 1})">调拨</c-button>
						<c-button v-if="data.buttons.return_to_stock?.visible && auth('b_app_quality_return')" @click="returnToStock([data])">返库</c-button>
						<c-button v-if="data.buttons.upload_image?.visible && auth('b_app_quality_upload_image')" color="main" hollow @click="mp.navigateWeb('/quality/assets', {code: data.produce_unique_code})">上传图片</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	import handoverReject from '@/mixins/handover_reject'
	import {mapGetters} from 'vuex'

	export default {
		mixins: [handoverReject],
		handoverModuleType: 1,
		computed: {
			...mapGetters(['hasHandover'])
		},

		data() {
			return {
			}
		},

		methods: {
			returnToStock(list) {
				this.$confirm({
					message: '确认要将该条记录返库吗？',
					resolve: () => {
						this.request({
							url: '/quality/return',
							data: {
								product_code_ids: list.map(item => item.product_code_id).join(',')
							},
							loading: true,
							success: () => {
								this.$message({message: '操作成功'});
								this.$refs.view.update();
							}
						});
					}
				});
			},
			/*********发布报告**********/
			publishReport(data, reportType) {
				let reportId = reportType == 1 ? data.b_report_id : data.c_report_id;
				if (!reportId) return;
				this.$confirm({
					message: '确认发布' + (reportType == 1 ? 'B端' : 'C端') + '质检报告吗？',
					resolve: () => {
						this.request({
							url: '/quality/report/batchPublish',
							data: {report_ids: String(reportId), report_type: reportType},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '发布成功'});
								this.$refs.view.update();
							}
						});
					}
				});
			},
			/*********下架报告**********/
			unpublishReport(data, reportType) {
				let reportId = reportType == 1 ? data.b_report_id : data.c_report_id;
				if (!reportId) return;
				this.$confirm({
					message: '确认下架' + (reportType == 1 ? 'B端' : 'C端') + '质检报告吗？',
					resolve: () => {
						this.request({
							url: '/quality/report/batchUnpublish',
							data: {report_ids: String(reportId), report_type: reportType},
							loading: true,
							success: () => {
								this.$message({message: '下架成功'});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>